<div class="assessment">
  <div class="assessment-content">
    <cw-dialog #dialog [title]='dialogTitle' [showCloseButton]='showCloseButton' [showLogo]='false' (eventHandler)="buttonAction('cancel')">
      <div class="custom-header-action">
        <ng-container></ng-container>
      </div>
      <div class="form-header" >{{dialogMessage}}</div>
      <form class="form-field-list" [formGroup]="assessmentTypeForm">
    <mat-form-field >
      <input type="text" matInput placeholder="Select Assessment" formControlName="assessment" [matAutocomplete]="assessments.auto" required>
      <cw-assessments-dropdown #assessments [searchControl]="assessmentTypeForm.controls.assessment" 
        [planId]="planId" [isInTrial]="isInTrial" [excludeTypeList]="['CERTIFICATION']">
      </cw-assessments-dropdown>
    </mat-form-field>
      </form>
      <button *ngIf="cancelButton" mat-button color="primary" (click)="buttonAction('cancel')">{{cancelButtonText}}</button>
      <button *ngIf="okButton" [disabled]="assessmentTypeForm.invalid" mat-raised-button type="button" color="primary" (click)="buttonAction()">{{continueButtonText}}</button>
    </cw-dialog>
  </div>
</div>
